export const STATUS = { 10: '草稿', 20: '审批中', 30: '已退回', 40: '已用印办结', 50: '已撤回' }
export const SEAL_NODE = '用印管理员执行用印'
// Replace source values when they are still untouched; retain values the applicant edited.
export function mergePurchaseDefaults(form, source = {}, previous = {}, fallback = {}) {
  const result = { ...form }
  const fields = ['purchaseApplyNo', 'purchaseApplyTitle', 'sealSubject', 'contractNo', 'contractName', 'signDate', 'contentDescription', 'contractTotalAmount', 'contractCount']
  for (const key of fields) {
    const current = form[key], old = previous[key]
    const empty = current == null || (typeof current === 'string' && !current.trim())
    const same = ['contractTotalAmount', 'contractCount'].includes(key) ? current != null && old != null && Number(current) === Number(old) : current === old
    if (key === 'purchaseApplyNo' || key === 'purchaseApplyTitle' || empty || (Object.prototype.hasOwnProperty.call(previous, key) && same)) {
      result[key] = Object.prototype.hasOwnProperty.call(source, key) ? source[key] : fallback[key] == null ? '' : fallback[key]
    }
  }
  const oldFiles = new Set((previous.fileInfoList || []).map(file => String(file.id)))
  const manualFiles = (form.fileInfoList || []).filter(file => !oldFiles.has(String(file.id)))
  const seen = new Set()
  result.fileInfoList = [...(source.fileInfoList || []), ...manualFiles].filter(file => file && file.id && !seen.has(String(file.id)) && seen.add(String(file.id)))
  return result
}
// Preserve the selected source even when it is outside the latest search page.
export function purchaseOptionRows(rows, selected) {
  const seen = new Set()
  const result = (Array.isArray(rows) ? rows : []).filter(row => row && row.id != null && ![115, 120].includes(Number(row.status))).filter(row => !seen.has(String(row.id)) && seen.add(String(row.id)))
  if (selected && selected.id != null && !seen.has(String(selected.id))) result.unshift(selected)
  return result
}
export function validate(form, submitting = true, companies) {
  if (typeof form.noPurchaseApply !== 'boolean') return '请选择关联采购申请或无'
  if (form.noPurchaseApply && !String(form.noPurchaseReason || '').trim()) return '选择无时必须填写无采购申请原因'
  if (!form.noPurchaseApply && !form.parentApplyId) return '请选择采购申请'
  if (form.noPurchaseApply && form.parentApplyId) return '选择无时不能同时关联采购申请'
  if (Array.isArray(companies) && !companies.some(company => company.companyName === form.sealSubject)) return '请选择有效的用印主体'
  if (!submitting) return ''
  for (const [key, label] of [['sealSubject', '用印主体'], ['contractNo', '合同编号'], ['contractName', '采购合同名称'], ['contentDescription', '合同内容说明']]) {
    if (!String(form[key] || '').trim()) return '请填写' + label
  }
  if (!form.signDate) return '请选择合同签署日期'
  if (!Number.isInteger(Number(form.copyCount)) || Number(form.copyCount) <= 0 || Number(form.copyCount) > 1000) return '文件份数须为1至1000'
  if (!['合同章', '公章'].includes(form.sealType)) return '请选择印章类型'
  if (!Number.isFinite(Number(form.contractTotalAmount)) || Number(form.contractTotalAmount) <= 0) return '请填写真实合同总额'
  if (!(form.fileInfoList || []).length) return '请上传合同附件'
  return ''
}
export function payload(form) {
  const keys = ['id', 'revision', 'sourceBatchId', 'noPurchaseApply', 'sealSubject', 'contractNo', 'contractName', 'signDate', 'contentDescription', 'contractTotalAmount', 'contractCount', 'copyCount', 'sealType', 'applyRemark']
  const result = {}; keys.forEach(key => { if (form[key] != null) result[key] = form[key] })
  return { ...result, parentApplyId: form.noPurchaseApply ? null : form.parentApplyId, noPurchaseReason: form.noPurchaseApply ? String(form.noPurchaseReason || '').trim() : '', fileInfoList: (form.fileInfoList || []).map(file => ({ id: file.id })) }
}
